<style lang="less">
    .menu-item {
        .menu-shortcut {
            color: #a0a0a0;
        }
    }
</style>

<template>
    <div>
        <div class="menu-item" v-for="(item, index) in layers" :key="index" @click="selectByLayer(index)">
            <span>{{ item.name }}</span>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-property-decorator";

    @Component({})
    export default class AlignMenus extends Vue {
        get layers() {
            return this.$store.state.page.activedPageLayers;
        }

        selectByLayer(index) {
            if (this.layers.length > 0) {
                index = this.layers.length - index - 1;
            }

            window["_view"].selectLayerShapes(index);
            this.$track("select", "select by layer", !index ? "background" : "Layer");
            this.$emit("closeDrop");
        }

        mounted() {}

        created() {}
    }
</script>
